import * as angular from 'angular';
import { skipLinkComponent } from './skip-links.component';

export const skipLinksModule = angular.module('skipLinksModule', [])
	.component('accessibilitySkipLinks', skipLinkComponent)
	.name;
